import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './BooksCreateUserConfirmAlert.module.scss';

interface Props {
  className?: string;
}

const BooksCreateUserConfirmAlert = ({ className }: Props) => {
  const classes = classNames(css.BooksCreateUserConfirmAlert, className);
  const intl = useIntl();

  return (
    <div className={classes}>
      <p className={css.BooksCreateUserConfirmAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.createUserConfirmAlertMessage"
          values={{
            terms: (
              <Link
                href="/user_terms"
                prefetch={false}
                className={css.BooksCreateUserConfirmAlert__Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({ id: 'books.forms.termOfUse' })}
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default BooksCreateUserConfirmAlert;
